import QueryItem from './query-item';

export default QueryItem;
